// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ZaiartLogin from './utils/login'
// import { share } from './utils/share'

// mintUI
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

// 公共css
import '@/assets/css/base.css'

// meta
import Meta from 'vue-meta'

import { Toast } from 'vant'

Vue.use(Meta)

Vue.use(MintUI)

Vue.config.productionTip = false

let toast = null
let whiteList = ['/login', '/bindphone', '/shop/item', '/course/detail','/live/room']

router.beforeEach((to, from, next) => {
  toast = Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    loadingType: 'spinner',
    message: '加载中...'
  })
  let isInWhiteList = false
  whiteList.forEach(element => {
    if(to.path.indexOf(element) == 0){
      isInWhiteList = true
    }
  });
  if (!isInWhiteList) {
    let zaiartLogin = new ZaiartLogin()
    zaiartLogin.login(function() {
      next()
    })
  } else {
    // 在免登录白名单，直接进入
    next()
  }
})

router.afterEach((to, from) => {
  toast.clear()
})

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// share({
//   title: '在艺App',
//   desc: '爱艺术的人都在这里',
//   link: 'https://www.zai-art.com',
//   imgUrl: 'https://img.zai-art.com/logo/512.png'
// })
